import React, { useEffect, useState } from "react";
import axios from "axios";
import { Box, Typography, Card, CardContent, LinearProgress, Grid, Divider } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import CircularProgress from '@mui/material/CircularProgress';
import SingleLogin from "../../../../../../helper/singlesign";
import { LearnersCourses } from "../../../../../../helper/base_url";
import useNetworkStatus from "../../../../../../helper/NetworkStatus";
import { ShimmerSimpleGallery } from "react-shimmer-effects";

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const { isOnline } = useNetworkStatus();

  const fetchCourses = async () => {
    setError(null);
    setLoading(true);

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setError("Authentication token not found");
        setLoading(false);
        return;
      }

      const response = await axios.get(`${LearnersCourses}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: { category: "EMBEDDED" },
      });

      //console.log("API Response:", response.data);

      setCourses(Array.isArray(response.data.courses) ? response.data.courses : []);
    } catch (err) {
      //console.error("Error fetching courses:", err);
      setError("Courses are not available.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="70vh">
        <CircularProgress color="primary" />
      </Box>
    );
  }

  return (
     <div>
      {isOnline ? (
        <Box sx={{ px: 4, py: 2 }}>
          <Typography
            variant="h5"
            sx={{ color: "#052659", fontWeight: 700, mb: 3 }}
          >
            My Active Courses
          </Typography>

          {error ? (
            <Box sx={{ textAlign: "center", mt: 1 }}>
                {/* <Alert severity="error">{error}</Alert> */}
            </Box>
          ) : !courses || courses.length === 0 ? (
            <Typography variant="body1" align="center">
              No active courses found.
            </Typography>
          ) : (
            <Grid container spacing={4}>
              {courses
                .filter(
                  (item) => item.productProgress > 0 && item.productProgress < 99
                )
                .map((item, index) => (
                  <Grid item xs={12} sm={6} md={4} key={item.productId}>
                    <Card
                      elevation={3}
                      sx={{
                        borderRadius: 3,
                        height : "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        p: 2,
                        bgcolor: "#ffffff",
                      }}
                    >
                      <CardContent sx={{ p: 0 }}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: 700,
                            fontSize: "1rem",
                            color: "#043885",
                            mb: 1,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {index + 1}. {item.productTitle}
                        </Typography>

                        <Box display="flex" alignItems="center" gap={2} mb={1}>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{ minWidth : 72 }}
                          >
                            Progress:{" "}
                            {Math.min(item.productProgress || 0, 100).toFixed(0)}%
                          </Typography>
                          <LinearProgress
                            variant="determinate"
                            value={Math.min(item.productProgress || 0, 100)}
                            sx={{
                              flexGrow: 1,
                              height : 8,
                              borderRadius: 5,
                              backgroundColor: "#e0e0e0",
                              "& .MuiLinearProgress-bar": {
                                backgroundColor: "#052659",
                              },
                            }}
                          />
                        </Box>

                        <Divider sx={{ my: 1 }} />

                        <Box sx={{ mt: 1 }}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              color: "#1B6EF4",
                              fontWeight: 600,
                              fontSize: "14px",
                              cursor: "pointer",
                            }}
                          >
                            <PlayArrowIcon fontSize="small" />
                            <SingleLogin videoUrl={item.productId} />
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
            </Grid>
          )}
        </Box>
      ) : (
        <Box>
           <ShimmerSimpleGallery card imageHeight={180} row={3} col={3} gap={20} />
        </Box>
      )}
    </div>
  );
};

export default Courses;
